
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { StudentSituationType } from "../../types/StudentSituation";
import { get, post, put } from "../../utils/axios-config";
import { STUDENT_SITUATIONS } from "../../utils/constants";


export const createStudentSituation = async (data: StudentSituationType) => {
    return await post<StudentSituationType, string>(STUDENT_SITUATIONS, data);
};

export const updateStudentSituation = async (data: StudentSituationType) => {
    return await put<StudentSituationType, string>(STUDENT_SITUATIONS, data);
};

export const getStudentSituations = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
        ...(data?.IdEnrollment ? { IdEnrollment: data.IdEnrollment } : {}),
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
    });
    const url = `${STUDENT_SITUATIONS}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentSituationType>>(url);
};
